// Google Analytics Tracking Utilities
// Tracking ID: AW-17954067730 (Google Ads) and G-W109871RVQ (GA4)

export const GA_TRACKING_ID = 'AW-17954067730';
export const GA4_TRACKING_ID = 'G-W109871RVQ';
export const CONVERSION_ID = 'AW-17954067730/psf_CNzp0fgbEJKqlfFC';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Track page view to both GA and backend
export const trackPageView = (url) => {
  // Google Analytics tracking
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
    window.gtag('config', GA4_TRACKING_ID, {
      page_path: url,
    });
  }
  
  // Backend tracking for internal analytics
  if (BACKEND_URL) {
    fetch(`${BACKEND_URL}/api/track/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: url || window.location.pathname,
        referrer: document.referrer || null
      })
    }).catch(() => {}); // Silent fail
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track course page view
export const trackCourseView = (courseName, courseId) => {
  trackEvent('view_item', 'Course', courseName, 0);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'course_view', {
      course_name: courseName,
      course_id: courseId,
    });
  }
};

// Track Book Now clicked
export const trackBookNowClicked = (courseName, courseId) => {
  trackEvent('begin_checkout', 'Booking', courseName, 0);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'book_now_clicked', {
      course_name: courseName,
      course_id: courseId,
    });
  }
};

// Track contact form opened
export const trackContactFormOpened = () => {
  trackEvent('generate_lead', 'Contact', 'Contact Form Opened', 0);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'contact_form_opened');
  }
};

// Track contact form submitted
export const trackContactFormSubmitted = (email, courseName) => {
  trackEvent('generate_lead', 'Contact', 'Contact Form Submitted', 0);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'contact_form_submitted', {
      course_interest: courseName,
    });
  }
};

// Track checkout initiated
export const trackCheckoutInitiated = (courseName, price) => {
  trackEvent('begin_checkout', 'Checkout', courseName, price);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'checkout_initiated', {
      course_name: courseName,
      value: price,
      currency: 'GBP',
    });
  }
};

// Track deposit completed - CONVERSION EVENT
export const trackDepositCompleted = (transactionId, courseName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Primary conversion event for Google Ads
    window.gtag('event', 'conversion', {
      'send_to': CONVERSION_ID,
      'value': 50.0,
      'currency': 'GBP',
      'transaction_id': transactionId,
    });
    
    // Also track as purchase event
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: 50.0,
      currency: 'GBP',
      items: [{
        item_name: courseName,
        price: 50.0,
      }],
    });
  }
};

// Track View Details clicked
export const trackViewDetailsClicked = (courseName, courseId) => {
  trackEvent('select_content', 'Course', courseName, 0);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_details_clicked', {
      course_name: courseName,
      course_id: courseId,
    });
  }
};
